<template lang="pug">
div
  b-navbar(variant="light", type="dark")
    b-container
      b-navbar-brand.mx-auto
        b-img(src="https://mandamelo.com.mx/assets/f2aef8e8727ab46f271ebc6f74b553eb.png", height="60")
  b-container#form-conatiner
    b-row
      b-col(lg="10", offset-lg="1")
        validation-observer(
          ref="global_observer",
          v-slot="{ invalid, handleSubmit, errors, failed }"
        )
          b-form(@submit.prevent="handleSubmit(submitData)")
            .pb-4
              h5.my-3.my-md-5 Nombre
              b-row
                b-col
                  validation-provider(
                    rules="required|max:200",
                    name="nombre completo",
                    v-slot="{ valid, errors }"
                  )
                    b-form-group(label="Nombre completo")
                      b-form-input(
                        placeholder="Nombre completo",
                        v-model="person.nombre",
                        autocomplete="off",
                        :state="errors[0] ? false : valid ? true : null"
                      )
                      b-form-invalid-feedback {{ errors[0] }}

              b-row
                b-col(md="6")
                  validation-provider(
                    rules="required|email|max:100",
                    name="correo electrónico",
                    v-slot="{ valid, errors }"
                  )
                    b-form-group(label="Correo electrónico")
                      b-form-input(
                        placeholder="Correo electrónico",
                        v-model="person.email",
                        autocomplete="off",
                        :state="errors[0] ? false : valid ? true : null",
                        type="email"
                      )
                      b-form-invalid-feedback {{ errors[0] }}
              //- b-row
              //-   b-col
              //-     validation-provider(rules="required" name="tipo de persona" v-slot="{ valid, errors }", vid="tipo_persona")
              //-       b-form-group(label="Tipo de persona:")
              //-         b-form-radio-group(:options="personTypeOptions", name="tipo_persona", v-model="person.tipo_persona", :state="errors[0] ? false : null")
              //- // nombre F
              //- div(v-show="person.tipo_persona == 'F'")
              //-   b-row
              //-     b-col(md="6")
              //-       validation-provider(:rules="{required: person.tipo_persona == 'F'}", name="nombre(s)" v-slot="{ valid, errors }")
              //-         b-form-group(label="Nombre(s)")
              //-           b-form-input(placeholder="Nombre(s)", v-model="person.nombre", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)")
              //-           b-form-invalid-feedback {{errors[0]}}
              //-     b-col(md="6")
              //-       validation-provider(:rules="{required: person.tipo_persona == 'F'}", name="apellido paterno" v-slot="{ valid, errors }")
              //-         b-form-group(label="Apellido paterno")
              //-           b-form-input(placeholder="Apellido paterno", v-model="person.a_paterno", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)")
              //-           b-form-invalid-feedback {{errors[0]}}
              //-     b-col(md="6")
              //-       validation-provider(:rules="{required: person.tipo_persona == 'F'}", name="apellido materno" v-slot="{ valid, errors }")
              //-         b-form-group(label="Apellido materno")
              //-           b-form-input(placeholder="Apellido materno", v-model="person.a_materno", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)")
              //-           b-form-invalid-feedback {{errors[0]}}
                //- b-row.mt-3.mt-md-4
                //-   b-col(md="6")
                //-     validation-provider(:rules="{required: person.tipo_persona == 'F'}", name="fecha de nacimiento" v-slot="{ valid, errors }")
                //-       b-form-group(label="Fecha de nacimiento", description="Formato: DD/MM/YYYY")
                //-         b-form-input(placeholder="Fecha de nacimiento", v-model="person.fecha_nacimiento", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'##/##/####'")
                //-         b-form-invalid-feedback {{errors[0]}}
              //- // nombre M
              //- b-row(v-show="person.tipo_persona == 'M'")
              //-   b-col(cols="12")
              //-     // alert nombre M
              //-     b-alert.text-center.my-3.my-md-4(variant="warning", show)
              //-       alert-triangle-icon.mr-2.icon-sm
              //-       span Ingresa los datos del representante legal
              //-   b-col(md="6")
              //-     validation-provider(:rules="{required: person.tipo_persona == 'M'}" name="nombre" v-slot="{ valid, errors }")
              //-       b-form-group(label="Nombre")
              //-         b-form-input(placeholder="Nombre", v-model="person.nombre_representante", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)")
              //-         b-form-invalid-feedback {{errors[0]}}
              //-   b-col(md="6")
              //-     validation-provider(rules="alpha_spaces" name="" v-slot="{ valid, errors, validated }")
              //-       b-form-group(label="Segundo nombre")
              //-         b-form-input(placeholder="Segundo nombre", v-model="person.segundo_nombre_representante", autocomplete="off", :state="errors[0] ? false : (valid && validated ? true : null)")
              //-         b-form-invalid-feedback {{errors[0]}}
              //-   b-col(md="6")
              //-     validation-provider(:rules="{required : person.tipo_persona == 'M'}" name="apellido paterno" v-slot="{ valid, errors }")
              //-       b-form-group(label="Apellido paterno")
              //-         b-form-input(placeholder="Apellido paterno", v-model="person.a_paterno_representante", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)")
              //-         b-form-invalid-feedback {{errors[0]}}
              //-   b-col(md="6")
              //-     validation-provider(:rules="{required : person.tipo_persona == 'M'}" name="apellido materno" v-slot="{ valid, errors }")
              //-       b-form-group(label="Apellido materno")
              //-         b-form-input(placeholder="Apellido materno", v-model="person.a_materno_representante", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)")
              //-         b-form-invalid-feedback {{errors[0]}}
              //-
              //- h5.my-3.my-md-5 Datos de contacto
              //- b-row
              //-   // alert contacto M
              //-   b-col(cols="12", v-show="person.tipo_persona == 'M'")
              //-     b-alert.text-center.my-3.my-md-4(variant="warning", show)
              //-       alert-triangle-icon.mr-2.icon-sm
              //-       span Datos de contacto del representante legal
              //-   b-col(md="6")
              //-     validation-provider(rules="required|email" name="correo electrónico" v-slot="{ valid, errors }")
              //-       b-form-group(label="Correo electrónico")
              //-         b-form-input(placeholder="Correo electrónico", v-model="person.email", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", type="email")
              //-         b-form-invalid-feedback {{errors[0]}}
              //-   // telefono F
                //- b-col(md="6", v-show="person.tipo_persona == 'F'")
                //-   b-form-row
                //-     b-col(cols="4")
                //-       validation-provider(:rules="{required: person.tipo_persona == 'F'}" name="lada" v-slot="{ valid, errors }")
                //-         b-form-group(label="Lada", description="Ej. CDMX: 55")
                //-           b-form-input(placeholder="00", v-model="person.lada_telefono", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'###?'")
                //-           b-form-invalid-feedback {{errors[0]}}
                //-     b-col
                //-       validation-provider(:rules="{required: person.tipo_persona == 'F'}" name="teléfono" v-slot="{ valid, errors }")
                //-         b-form-group(label="Teléfono", description="8 dígitos")
                //-           b-form-input(placeholder="00000000", v-model="person.telefono", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'########'")
                //-           b-form-invalid-feedback {{errors[0]}}
                b-col(md="6", v-show="person.tipo_persona == 'F'")
                  b-form-row
                    //- b-col(cols="4")
                    //-   validation-provider(:rules="{required: person.tipo_persona == 'F'}" name="lada celular" v-slot="{ valid, errors }")
                    //-     b-form-group(label="Lada", description="Ej. CDMX: 55")
                    //-       b-form-input(placeholder="00", v-model="person.lada_celular", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'###?'")
                    //-       b-form-invalid-feedback {{errors[0]}}
                    b-col
                      validation-provider(:rules="{required: person.tipo_persona == 'F'}" name="celular" v-slot="{ valid, errors }")
                        b-form-group(label="Celular", description="10 dígitos")
                          b-form-input(placeholder="00000000", v-model="person.tel_celular", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'##-####-####'")
                          b-form-invalid-feedback {{errors[0]}}

                // telefono M
                //- b-col(md="6", v-show="person.tipo_persona == 'M'")
                //-   b-form-row
                //-     b-col(cols="4")
                //-       validation-provider(:rules="{required: person.tipo_persona == 'M'}" name="lada respresentante legal" v-slot="{ valid, errors }")
                //-         b-form-group(label="Lada", description="Ej. CDMX: 55")
                //-           b-form-input(placeholder="00", v-model="person.lada_telefono_representante", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'###?'")
                //-           b-form-invalid-feedback {{errors[0]}}
                //-     b-col
                //-       validation-provider(:rules="{required: person.tipo_persona == 'M'}" name="teléfono representante legal" v-slot="{ valid, errors }")
                //-         b-form-group(label="Teléfono", description="8 dígitos")
                //-           b-form-input(placeholder="00000000", v-model="person.telefono_representante", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'########'")
                //-           b-form-invalid-feedback {{errors[0]}}
                b-col(md="6", v-show="person.tipo_persona == 'M'")
                  b-form-row
                    //- b-col(cols="4")
                    //-   validation-provider(:rules="{required: person.tipo_persona == 'M'}" name="lada celular representante legal" v-slot="{ valid, errors }")
                    //-     b-form-group(label="Lada", description="Ej. CDMX: 55")
                    //-       b-form-input(placeholder="00", v-model="person.lada_celular_representante", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'###?'")
                    //-       b-form-invalid-feedback {{errors[0]}}
                    b-col
                      validation-provider(:rules="{required: person.tipo_persona == 'M'}" name="celular representante legal" v-slot="{ valid, errors }")
                        b-form-group(label="Celular", description="10 dígitos")
                          b-form-input(placeholder="00000000", v-model="person.tel_celular_representante", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'##-####-####'")
                          b-form-invalid-feedback {{errors[0]}}

              h5.my-3.my-md-5 Dirección de envío
                //- span.ml-1(v-show="person.tipo_persona == 'M'") de la empresa
              validation-observer(ref="address_form")
                b-row
                  b-col(cols="12")
                    b-form-group(
                      label="Buscar dirección:",
                      description="Selecciona tu dirección del autocompletado. Por Google."
                    )
                      b-form-input#search_autocomplete(
                        placeholder="Empieza a escribir la dirección",
                        autocomplete="off",
                        @focus="setAutocompleteOff($event.target)"
                      )
                  b-col(cols="12", v-show="verifyAddressData")
                    b-alert.text-center(show, variant="info")
                      alert-circle-icon.mr-2.icon-sm
                      span Por favor, verifica que todos los datos sean correctos
                  b-col.mb-2(cols="12", v-show="!placeFieldsDisabled")
                    #map(:style="{ height: '300px' }")
                  b-col(md="6")
                    validation-provider(
                      rules="required|max:100",
                      name="calle",
                      v-slot="{ valid, errors }"
                    )
                      b-form-group(label="Calle")
                        b-form-input(
                          placeholder="Calle",
                          v-model="person.calle",
                          autocomplete="off",
                          :state="errors[0] ? false : valid ? true : null",
                          :disabled="autocompleteDisabled"
                        )
                        b-form-invalid-feedback {{ errors[0] }}
                  b-col(md="6")
                    validation-provider(
                      rules="required|max:10",
                      name="no. exterior",
                      v-slot="{ valid, errors }"
                    )
                      b-form-group(label="Número exterior")
                        b-form-input(
                          placeholder="No. exterior",
                          v-model="person.num_exterior",
                          autocomplete="off",
                          :state="errors[0] ? false : valid ? true : null",
                          :disabled="autocompleteDisabled"
                        )
                        b-form-invalid-feedback {{ errors[0] }}
                  b-col(md="6")
                    validation-provider(
                      :rules="{ regex: /(.+)?/, max: 10 }",
                      name="no. interior",
                      v-slot="{ valid, errors, validated }"
                    )
                      b-form-group(label="Número interior")
                        b-form-input(
                          placeholder="Número interior",
                          v-model="person.num_int",
                          autocomplete="off",
                          :state="errors[0] ? false : valid && validated ? true : null",
                          :disabled="autocompleteDisabled"
                        )
                        b-form-invalid-feedback {{ errors[0] }}
                  b-col(md="6")
                    validation-provider(
                      rules="required|max:60",
                      name="colonia",
                      v-slot="{ valid, errors }"
                    )
                      b-form-group(label="Colonia")
                        b-form-input(
                          placeholder="Colonia",
                          v-model="person.colonia",
                          autocomplete="off",
                          :state="errors[0] ? false : valid ? true : null",
                          :disabled="autocompleteDisabled"
                        )
                        b-form-invalid-feedback {{ errors[0] }}
                  b-col(md="6")
                    validation-provider(
                      rules="required|max:50",
                      name="alcaldía o municipio",
                      v-slot="{ valid, errors }"
                    )
                      b-form-group
                        p.mb-2 Alcaldía o municipio
                          b-spinner.ml-2(
                            variant="primary",
                            small,
                            v-if="loadingMunicipality"
                          )
                        b-form-input(
                          placeholder="Alcaldía o municipio",
                          v-model="person.delegacionmunicipio",
                          autocomplete="off",
                          :state="errors[0] ? false : valid ? true : null",
                          :disabled="autocompleteDisabled"
                        )
                        b-form-invalid-feedback {{ errors[0] }}
                  b-col(md="6")
                    validation-provider(
                      rules="required|max:50",
                      name="estado",
                      v-slot="{ valid, errors }"
                    )
                      b-form-group(label="Estado")
                        b-form-input(
                          placeholder="Estado",
                          v-model="person.estado",
                          autocomplete="off",
                          :state="errors[0] ? false : valid ? true : null",
                          :disabled="autocompleteDisabled"
                        )
                        b-form-invalid-feedback {{ errors[0] }}
                  b-col(md="6")
                    validation-provider(
                      rules="required|max:50",
                      name="ciudad",
                      v-slot="{ valid, errors }"
                    )
                      b-form-group(label="Ciudad")
                        b-form-input(
                          placeholder="Ciudad",
                          v-model="person.ciudadpoblacion",
                          autocomplete="off",
                          :state="errors[0] ? false : valid ? true : null",
                          :disabled="autocompleteDisabled"
                        )
                        b-form-invalid-feedback {{ errors[0] }}
                  b-col(md="6")
                    validation-provider(
                      rules="required|digits:5",
                      name="CP",
                      v-slot="{ valid, errors }"
                    )
                      b-form-group(label="Código postal")
                        b-form-input(
                          placeholder="Código postal",
                          v-model="person.cp",
                          autocomplete="off",
                          :state="errors[0] ? false : valid ? true : null",
                          v-mask="'#####'",
                          :disabled="autocompleteDisabled"
                        )
                        b-form-invalid-feedback {{ errors[0] }}

              //- h5.my-3.my-md-5 Datos bancarios
              //- b-row
              //-   // alert bancarios M
              //-   //- b-col(cols="12", v-show="person.tipo_persona == 'M'")
              //-   //-   b-alert.text-center.my-3.my-md-4(variant="warning", show)
              //-   //-     alert-triangle-icon.mr-2.icon-sm
              //-   //-     span Ingresa los datos de la empresa
              //-   b-col(md="6")
              //-     validation-provider(rules="alpha_num" name="RFC" v-slot="{ valid, errors, validated }")
              //-       b-form-group(label="RFC (opcional)", description="Con homoclave.")
              //-         b-form-input(placeholder="RFC - opcional", :value="person.rfc", @input="person.rfc = $event.toUpperCase()", autocomplete="off", :state="errors[0] || !isRFCValid ? false : (valid && validated ? true : null)")
              //-         b-form-invalid-feedback {{errors[0]}}
              //-   b-col(md="6")
              //-     validation-provider(rules="required|digits:18" name="CLABE" v-slot="{ valid, errors }")
              //-       b-form-group(label="Cuenta CLABE", description="Lo puedes encontrar en tu estado de cuenta bancario. 18 dígitos.")
              //-         b-form-input(placeholder="CLABE", v-model="person.cuentaclabe", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'##################'")
              //-         b-form-invalid-feedback {{errors[0]}}
              //-   b-col(md="6", v-show="person.tipo_persona == 'M'")
              //-     validation-provider(:rules="{required: person.tipo_persona == 'M'}" name="razón social" v-slot="{ valid, errors }")
              //-       b-form-group(label="Razón social")
              //-         b-form-input(placeholder="Razón social", v-model="person.razon_social", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)")
              //-         b-form-invalid-feedback {{errors[0]}}

              //- h5.my-3.my-md-5(v-if="person.tipo_persona == 'M'") Datos
              //-   span.ml-1(v-if="person.tipo_persona == 'M'") de la empresa
              //-   span.ml-1(v-else) del comercio
              //- b-row(v-if="person.tipo_persona == 'M'")
                //- b-col(md="6")
                //-   validation-provider(rules="required" name="giro comercial" v-slot="{ valid, errors }")
                //-     b-form-group(label="Giro comercial")
                //-       b-form-select(:options="giros", v-model="person.cdGiro", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)")
                //-         template(v-slot:first)
                //-           b-form-select-option(:value="null", disabled) -- Seleccionar giro --
                //-       b-form-invalid-feedback {{errors[0]}}
                //- b-col(md="6", v-show="person.tipo_persona == 'M'")
                //-   validation-provider(:rules="{required: person.tipo_persona == 'M'}" name="razón social" v-slot="{ valid, errors }")
                //-     b-form-group(label="Razón social")
                //-       b-form-input(placeholder="Razón social", v-model="person.razon_social", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)")
                //-       b-form-invalid-feedback {{errors[0]}}
                //- b-col(md="6", v-show="person.tipo_persona == 'M'")
                //-   validation-provider(:rules="{required: person.tipo_persona == 'M'}" name="fecha de registro" v-slot="{ valid, errors }")
                //-     b-form-group(label="Fecha de registro", description="Como aparece en acta constitutiva. Formato: DD/MM/YYYY")
                //-       b-form-input(placeholder="Fecha de registro", v-model="person.f_registro_acta_constitutiva", autocomplete="off", :state="errors[0] ? false : (valid ? true : null)", v-mask="'##/##/####'")
                //-       b-form-invalid-feedback {{errors[0]}}

              //- h5.my-3.my-md-5 Sube tus documentos
              //- b-row
              //-   b-col(md="6")
              //-     validation-provider(rules="required" name="identificación oficial - anverso" v-slot="{ valid, errors }")
              //-       b-form-group
              //-         p.mb-2 Identificación oficial - FRENTE
              //-           b-link.text-danger.ml-3(v-if="person.imagen_identificacion", @click="person.imagen_identificacion = null") Quitar
              //-         b-form-file(accept="image/*,.pdf", placeholder="Da click o arrastra tu archivo", drop-placeholder="Suelta tu archivo aquí...", browse-text="Examinar", :state="errors[0] ? false : (valid ? true : null)", v-model="person.imagen_identificacion", @input="fileSelected('imagen_identificacion', $event)")
              //-         b-form-invalid-feedback {{errors[0]}}
              //-   b-col(md="6")
              //-     validation-provider(rules="required" name="identificación oficial - reverso" v-slot="{ valid, errors }")
              //-       b-form-group
              //-         p.mb-2 Identificación oficial - ATRÁS
              //-           b-link.text-danger.ml-3(v-if="person.imagen_identificacion_reverso", @click="person.imagen_identificacion_reverso = null") Quitar
              //-         b-form-file(accept="image/*,.pdf", placeholder="Da click o arrastra tu archivo", drop-placeholder="Suelta tu archivo aquí...", browse-text="Examinar", :state="errors[0] ? false : (valid ? true : null)", v-model="person.imagen_identificacion_reverso", @input="fileSelected('imagen_identificacion_reverso', $event)")
              //-         b-form-invalid-feedback {{errors[0]}}
                //- b-col(md="6")
                //-   validation-provider(rules="required" name="estado de cuenta" v-slot="{ valid, errors }")
                //-     b-form-group(description="El archivo debe ser no mayor a 3 meses.")
                //-       p.mb-2 Estado de cuenta
                //-         b-link.text-danger.ml-3(v-if="person.imagen_estado_de_cuenta", @click="person.imagen_estado_de_cuenta = null") Quitar
                //-       b-form-file(accept="image/*,.pdf", placeholder="Da click o arrastra tu archivo", drop-placeholder="Suelta tu archivo aquí...", browse-text="Examinar", :state="errors[0] ? false : (valid ? true : null)", v-model="person.imagen_estado_de_cuenta", @input="fileSelected('imagen_estado_de_cuenta', $event)")
                //-       b-form-invalid-feedback {{errors[0]}}

              b-row.mt-3.mt-md-5
                b-col.text-center(md="6")
                  validation-provider(
                    :rules="{ required: { allowFalse: false } }",
                    name="términos y condiciones",
                    v-slot="{ valid, errors }"
                  )
                    b-form-group
                      b-form-checkbox(
                        :state="errors[0] ? false : valid ? true : null",
                        v-model="terms"
                      ) Acepto los
                        b-link.ml-1(
                          href="https://mandamelo.com.mx/terminos.html",
                          target="_blank"
                        ) términos y condiciones
                          external-link-icon.icon-sm.mb-1.ml-1
                      b-form-invalid-feedback {{ errors[0] }}
                b-col.text-center(md="6")
                  validation-provider(
                    :rules="{ required: { allowFalse: false } }",
                    name="aviso de privacidad",
                    v-slot="{ valid, errors }"
                  )
                    b-form-group
                      b-form-checkbox(
                        :state="errors[0] ? false : valid ? true : null",
                        v-model="privacy"
                      ) He leído el
                        b-link.ml-1(
                          href="https://mandamelo.com.mx/privacidad.html",
                          target="_blank"
                        ) aviso de privacidad
                          external-link-icon.icon-sm.mb-1.ml-1
                      b-form-invalid-feedback {{ errors[0] }}

              b-row.mt-3.mt-md-5
                b-col(cols="12")
                  p.text-center.text-danger(v-if="failed") * Completa los campos faltantes
                b-col.my-3(md="8", offset-md="2", v-if="progress > 0")
                  b-progress :value="progress" :max="100" show-progress animated
                b-col(md="8", offset-md="2")
                  b-button(
                    variant="primary",
                    block,
                    type="submit",
                    :disabled="disabled"
                  ) Registrarme
</template>

<script>
import Vue from "vue";
import axios from "axios";

// maps callback
const EventBus = new Vue();
window.initUserPlaces = function () {
  EventBus.$emit("user_places_loaded");
};

import { toBase64 } from "@/helpers/file-converter";

export default {
  name: "Home",
  data() {
    return {
      autocomplete: null,
      autocompleteDisabled: true,
      map: null,
      geocoder: null,
      placeFieldsDisabled: true,
      loadingMunicipality: false,
      terms: false,
      privacy: false,
      progress: 0,
      disabled: false,
      personTypeOptions: [
        {
          text: "Persona Física",
          value: "F",
        },
        {
          text: "Persona Moral",
          value: "M",
        },
      ],
      verifyAddressData: false,
      place_fields: {
        street_number: "short_name",
        route: "long_name",
        sublocality_level_1: "long_name",
        locality: "long_name",
        administrative_area_level_1: "short_name",
        country: "long_name",
        postal_code: "short_name",
      },
      person: {
        tipo_persona: "", // F || M
        nombre: "",
        a_paterno: "",
        a_materno: "",
        email: "",
        lada_telefono: "", // 55
        telefono: "", // 8 dígitos
        lada_celular: "", // 55
        tel_celular: "", // 8 dígitos

        rfc: "", // homoclave

        full_address: "",
        calle: "", // street
        num_exterior: "", // street_number
        num_int: "", // number or NA
        delegacionmunicipio: "",
        colonia: "", // colony
        ciudadpoblacion: "", // city
        estado: "", // state
        cp: "", // zip

        cdGiro: null, // inversionista
        // "id_sistema": "F12591-545577",
        cuentaclabe: "", // clabe
        // "sucursal": "12345", // get sucursal
        // "plaza": "123", // get plaza
        fecha_nacimiento: "", // dd/mm/yyyy
        imagen_identificacion: null, // base64 not clean
        imagen_estado_de_cuenta: null, // base64 not clean
        imagen_identificacion_reverso: null,

        ///////////////
        // moral person
        razon_social: "",
        f_registro_acta_constitutiva: "", // dd/mm/yyyy
        nombre_representante: "",
        segundo_nombre_representante: "",
        a_paterno_representante: "",
        a_materno_representante: "",
        lada_celular_representante: "", // 55
        tel_celular_representante: "", // 8 dígitos
        lada_telefono_representante: "", // 55
        telefono_representante: "", // 8 dígitos
        latitude: null,
        longitude: null,
      },
      giros: [
        { value: "Agente de viajes ", text: "Agente de viajes " },
        { value: "Agropecuario ", text: "Agropecuario " },
        { value: "Arrendamiento ", text: "Arrendamiento " },
        { value: "Artículos ferretería ", text: "Artículos ferretería " },
        { value: "Asesoría ", text: "Asesoría " },
        { value: "Aviación ", text: "Aviación " },
        { value: "Capacitación ", text: "Capacitación " },
        { value: "Combustión ", text: "Combustión " },
        { value: "Comercial ", text: "Comercial " },
        { value: "Compras ", text: "Compras " },
        { value: "Comunicaciones ", text: "Comunicaciones " },
        { value: "Confección ", text: "Confección " },
        { value: "Construcción ", text: "Construcción " },
        { value: "Consultoría ", text: "Consultoría " },
        { value: "Contable ", text: "Contable " },
        { value: "Corsetería ", text: "Corsetería " },
        { value: "Diseño Gráfico ", text: "Diseño Gráfico " },
        { value: "Distribución ", text: "Distribución " },
        { value: "Editorial ", text: "Editorial " },
        { value: "Educación ", text: "Educación " },
        {
          value: "Ensamblado de Computadoras ",
          text: "Ensamblado de Computadoras ",
        },
        { value: "Fútbol ", text: "Fútbol " },
        { value: "Gobierno", text: "Gobierno" },
        { value: "Habilitadora ", text: "Habilitadora " },
        { value: "Independiente ", text: "Independiente " },
        { value: "Industria ", text: "Industria " },
        { value: "Informática ", text: "Informática " },
        { value: "Inversionista ", text: "Inversionista " },
        { value: "Investigación ", text: "Investigación " },
        { value: "Jurídico ", text: "Jurídico " },
        { value: "Línea de Cosméticos ", text: "Línea de Cosméticos " },
        { value: "Material ", text: "Material " },
        { value: "Mesa de Control ", text: "Mesa de Control " },
        { value: "Multivalores ", text: "Multivalores " },
        { value: "Música ", text: "Música " },
        { value: "Organización ", text: "Organización " },
        { value: "Otros ", text: "Otros " },
        { value: "Política ", text: "Política " },
        { value: "Productora de Videos ", text: "Productora de Videos " },
        { value: "Seguridad Pública ", text: "Seguridad Pública " },
        { value: "Seguros ", text: "Seguros " },
        { value: "Servicios ", text: "Servicios " },
        { value: "Servicios Financieros ", text: "Servicios Financieros " },
        { value: "Telecomunicaciones ", text: "Telecomunicaciones " },
        { value: "Tesorería ", text: "Tesorería " },
        { value: "Textil ", text: "Textil " },
        { value: "Ventas ", text: "Ventas " },
        { value: "Videos", text: "Videos" },
      ],
      imagen_identificacion: "", // base64 not clean
      imagen_estado_de_cuenta: "", // base64 not clean
      imagen_identificacion_reverso: "",
    };
  },
  computed: {
    isRFCValid() {
      if (!this.person.rfc) return true;
      let regex = /^([A-Z,Ñ,&]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1])[A-Z|\d]{3})$/;
      return regex.test(this.person.rfc);
    },
  },
  methods: {
    submitData() {
      function getParameterByName(name, url) {
        if (!url) url = window.location.href;
        name = name.replace(/[\[\]]/g, "\\$&");
        var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
          results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return "";
        return decodeURIComponent(results[2].replace(/\+/g, " "));
      }
      // sending data... :v
      let person = JSON.parse(JSON.stringify(this.person));
      for (let key in person) {
        if (
          key == "imagen_identificacion" ||
          key == "imagen_estado_de_cuenta" ||
          key == "imagen_identificacion_reverso"
        ) {
          person[key] = this[key];
        } else if (key == "num_int" && !person[key]) {
          person[key] = "NA";
        } else if (/^tel_celular/gim.test(key)) {
          person[key] = person[key].replace(/\-/gim, "");
        }

        if (!person[key]) delete person[key];
      }

      let data = {
        cipher: getParameterByName("cipher") || "",
        resource: person,
      };

      console.log(JSON.stringify(data));

      this.disabled = true;
      axios
        .post("/view-webhook", data, {
          onUploadProgress: (progressEvent) => {
            this.progress = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          },
        })
        .then((response) => {
          // console.log(response.data);
          const platform = getParameterByName('platform');

          let extraParams = '';

          if (platform.includes('whatsapp')) {
            extraParams += '&phone=525528970020&noclose=true';
          }

          if (response.data.success) {
            window.history.replaceState(
              {},
              null,
              "/status/success?clang=es&message=En breve recibirás un mensaje de confirmación" + extraParams
            );
            location.reload(true);
          } else {
            window.history.replaceState(
              {},
              null,
              "/status/error?clang=es&message=Regresa a lo conversación e intenta de nuevo" + extraParams
            );
            location.reload(true);
          }
        });
      // axios.post(<<CAMBIAR_URL>>, person);
    },
    getMunicipality(zipCode) {
      if (!zipCode) return;
      this.loadingMunicipality = true;
      axios
        .get(`https://beachhouse.botlers.io/utils/zipcode/${zipCode}`, {
          headers: {
            "x-api-key": "iSxq2AVlu06Gc2UPwRyZ89a3LvuN7Wgp3gxp39Il",
          },
        })
        .then((res) => {
          let resource = res.data.resource;

          if (resource && Array.isArray(resource)) {
            this.person.delegacionmunicipio = resource[0]["D_mnpio"];
            this.loadingMunicipality = false;
          }
        })
        .catch((error) => {
          console.log(error.message);
          this.loadingMunicipality = false;
        });
    },
    async fileSelected(attr, file) {
      if (file) {
        if (file.size > 1024 * 1024 * 2) {
          this.$bvModal
            .msgBoxOk("El peso del archivo no debe exceder los 2MB.", {
              okVariant: "primary",
              okTitle: "Entendido",
              centered: true,
            })
            .then((done) => {
              this.person[attr] = null;
            })
            .catch();
          return;
        }

        let file64 = await toBase64(file, false);
        this[attr] = file64;
      }
    },
    setAutocompleteOff(target) {
      target.setAttribute("autocomplete", "nope");
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition((position) => {
          const geolocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };
          const circle = new google.maps.Circle({
            center: geolocation,
            radius: position.coords.accuracy,
          });
          this.autocomplete.setBounds(circle.getBounds());
        });
      }
    },
    setPlace(place) {
      for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        switch (addressType) {
          case "street_number":
            this.person.num_exterior =
              place.address_components[i][this.place_fields[addressType]];
            break;
          case "route":
            this.person.calle =
              place.address_components[i][this.place_fields[addressType]];
            break;
          case "sublocality_level_1":
            this.person.colonia =
              place.address_components[i][this.place_fields[addressType]];
            break;
          case "locality":
            this.person.ciudadpoblacion =
              place.address_components[i][this.place_fields[addressType]];
            break;
          case "administrative_area_level_1":
            this.person.estado =
              place.address_components[i][this.place_fields[addressType]];
            break;
          case "postal_code":
            this.person.cp =
              place.address_components[i][this.place_fields[addressType]];
            break;
        }
      }

      this.person.num_int = "NA";

      this.$nextTick(() => {
        this.$refs.address_form.validate();
      });
      // this.person.full_address = place.formatted_address;
      // this.person.pickup_location_id = place.id;
      // this.person.map_image = place.url;
      this.person.latitude = place.geometry.location.lat();
      this.person.longitude = place.geometry.location.lng();
      this.placeMarker({
        lat: this.person.latitude,
        lng: this.person.longitude,
      });

      if (this.person.cp != undefined) {
        this.getMunicipality(this.person.cp);
      }
    },
    placeMarker(position) {
      if (!this.marker) {
        this.marker = new google.maps.Marker({
          position: position,
          map: this.map,
        });
        this.map.panTo(position);
      } else {
        this.marker.setPosition(position);
      }
      this.map.setZoom(17);
    },
    getPlaceByLocation(latLng) {
      return new Promise((resolve, reject) => {
        this.geocoder.geocode({ latLng }, (responses) => {
          if (responses && responses.length > 0) {
            resolve(responses[0]);
          } else {
            reject("An error ocurred while geolocating");
          }
        });
      });
    },
  },
  mounted() {
    EventBus.$on("user_places_loaded", () => {
      this.autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("search_autocomplete")
        // {types: ['geocode', 'establishment']}
      );

      this.geocoder = new google.maps.Geocoder();
      this.map = new google.maps.Map(document.getElementById("map"), {
        center: { lat: 19.432608, lng: -99.133209 }, // Mexico City
        zoom: 10,
        streetViewControl: false,
      });
      this.map.addListener("click", async (e) => {
        const place = await this.getPlaceByLocation(e.latLng);
        this.setPlace(place);
      });

      this.autocomplete.addListener("place_changed", () => {
        this.placeFieldsDisabled = false;
        this.verifyAddressData = true;
        let place = this.autocomplete.getPlace();
        this.setPlace(place);
      });
      this.autocompleteDisabled = false;
    });

    if (!document.getElementById("google-maps-sdk")) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script["data-name"] = "maps-api";
      script.id = "google-maps-sdk";
      script.src =
        "https://maps.googleapis.com/maps/api/js?key=AIzaSyDaTstVEjZI9hnqEcBgdZwTCdQxhLQTmGg&libraries=places&callback=initUserPlaces&language=es";
      document.getElementsByTagName("head")[0].appendChild(script);
    }
  },
};
</script>
